import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultAvatar from 'components/Avatar';
import { Body, Small } from 'components/Typography';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  cursor: pointer;
`;

// TODO: TFR-44 move to container group
export const Fragment = styled.div`
  margin-left: 3.125rem;
`;

// TODO: TFR-44 move to container group
export const Wrap = styled.div`
  display: flex;
  align-items: center;
  margin-left: 3.125rem;
`;

// TODO: TFR-44 move to typography group
export const Comment = styled(Small)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-44 move to typography group
const Text = styled(Body)`
  text-align: right;
`;

// TODO: TFR-44 move to typography group
export const Subtotal = styled(Text)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const DarkText = styled(Text)``;

// TODO: TFR-44 move to typography group
export const LightText = styled(Text)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-45:Avatar make unique name or do not export
export const Avatar = styled(DefaultAvatar)`
  margin-right: 1rem;
`;
